import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';
@Component({
    selector: 'app-customer-wishlist',
    templateUrl: './customer-wishlist.component.html',
    styleUrls: ['./customer-wishlist.component.scss'],
    standalone: false
})
export class CustomerWishlistComponent implements OnInit {
  _id: any
  headingName:any ='WISHLIST'
  linkerRouteItems:any =[
    { name:'Home',route: '/home'},
    {name:'Wishlist',route:'/wishlist-customer'}
  ]
  constructor(private activatedroute: ActivatedRoute, public commonService: CommonService, private router: Router) {
    this.activatedroute.queryParams.subscribe((res: any) => {
      this._id = res._id;
    })
  }

  ngOnInit(): void {
    this.getWishListProducts();
  }



  userId: any;
  productDetails: any[] = [];
  productId: any;
  retailerId: any;
  imgurl: any;
  imageLinks: any;
  currentPage: any = 1;
  limit: any = 15;
  totalItems: number = 0;
  readonly skeletonPlaceholders = Array.from({ length: 8 });

  // get retailer detail by id
  isLoading: boolean = true;
  getWishListProducts() {
    this.isLoading = true;
    let apiReqUrl: any = `user/WishList?page=${this.currentPage}&limit=${this.limit}`;
    this.commonService.showSpinner();
    this.commonService.getApi(apiReqUrl, 1).subscribe(
      (res: any) => {
        if (res?.responseCode === 200) {
          this.productDetails = res?.result?.docs || [];
          this.totalItems = res?.result?.total || 0;
          this.imageLinks = res?.result?.['thumbnail'];
          this.commonService.successToast('Wishlist loaded successfully');
        } else {
          this.productDetails = [];
          this.totalItems = 0;
          this.commonService.errorToast(res?.responseMessage || 'Failed to load wishlist');
        }

        this.isLoading = false;
        this.commonService.hideSpinner();
      },
      (err) => {
        this.isLoading = false;
        this.productDetails = [];
        this.totalItems = 0;
        this.commonService.hideSpinner();
        this.commonService.errorToast('Failed to load wishlist');
      }
    );
  }

  pagination(event) {
    this.currentPage = event;
    this.getWishListProducts();
  }



  forID(_id: any) {
    this.router.navigate(['/edit-product'], { queryParams: { _id: _id } })

  }
  toggleWishlist(productId: string) {
    // Find the product in the current list
    const product = this.productDetails.find(item => item.productId._id === productId);
    if (!product) return;
    
    console.log('Toggle wishlist for product:', productId, 'Current isLike status:', product.isLike);
    
    if (product.isLike) {
      // Remove from wishlist
      console.log('Removing from wishlist');
      this.removeFromWishlist(productId);
    } else {
      // Add to wishlist
      console.log('Adding to wishlist');
      this.addWishlist(productId);
    }
  }
  
  addWishlist(id) {
    let apiReqUrl = `user/addWishListProduct?productId=${id}`
    this.commonService.showSpinner();
    this.commonService.postApi(apiReqUrl, {}, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        // Update the product's wishlist status
        const product = this.productDetails.find(item => item.productId._id === id);
        if (product) {
          product.isLike = true;
        }
        this.commonService.hideSpinner();
        this.commonService.successToast('Product added to wishlist.');
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage)
        if (res.responseCode == 401) {
          this.router.navigate[('/login')]
        }
      }
    }, (err) => {
      this.commonService.hideSpinner()
      if (err.responseCode == 401) {
        this.router.navigate[('/login')]
      }
    })
  }
  
  removeFromWishlist(productId: string) {
    // Use the same addWishListProduct endpoint - it's a toggle function!
    // The backend will automatically remove the item if it's already in wishlist
    const apiReqUrl = `user/addWishListProduct?productId=${productId}`;
    this.commonService.showSpinner();
    
    this.commonService.postApi(apiReqUrl, {}, 1).subscribe((res: any) => {
      this.commonService.hideSpinner();
      if (res.responseCode == 200) {
        // Success - backend toggled the item (removed it)
        this.commonService.successToast('Item removed from wishlist');
        // Refresh the wishlist to reflect the change
        this.getWishListProducts();
      } else {
        this.commonService.errorToast(res.responseMessage || 'Failed to remove from wishlist');
      }
    }, (err) => {
      this.commonService.hideSpinner();
      this.commonService.errorToast('Something went wrong');
    });
  }
  
  removeFromWishlistLocal(productId: string) {
    // Fallback: Remove locally and show message
    const product = this.productDetails.find(item => item.productId._id === productId);
    if (product) {
      product.isLike = false;
    }
    
    this.commonService.successToast('Item removed from wishlist (local). Server sync may be delayed.');
    
    // Refresh the wishlist after a delay
    setTimeout(() => {
      this.getWishListProducts();
    }, 1000);
  }
  navigateToViewProduct(_id) {
    this.router.navigate(['/product-view-customer'], { queryParams: { _id: _id } })
  }
  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }
}

